const autoNgTemplateLoaderTemplate1 = require('./host-browser-view.html');

angular.module('shbdeployer.docker').component('hostBrowserView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'HostBrowserViewController',
  bindings: {
    endpoint: '<',
  },
});
